var map = {
	"./Club.webp": 46735,
	"./Extra(2).webp": 69752,
	"./Extra.webp": 94805,
	"./Gandhi Jayanti .webp": 65460,
	"./Home pages.webp": 65476,
	"./IMG_9637.JPG.webp": 14739,
	"./Mothers day celebration .webp": 13509,
	"./Photo gallery(1).webp": 22143,
	"./Photo gallery.webp": 53358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5597;